module.exports = __webpack_public_path__ + "media/svg-new/icon-desempenho-e7daf21c.svg";